export const EMPTY_PREFILL = { name: '', email: '', prefilledName: null, prefilledEmail: null };
const untouched = (value, prefill) => value === '' || value === (prefill ?? '');
export function prefillStep(s, e) {
    switch (e.type) {
        case 'match': {
            const next = { ...s };
            if (untouched(s.name, s.prefilledName)) {
                next.name = e.name ?? '';
                next.prefilledName = e.name;
            }
            if (untouched(s.email, s.prefilledEmail)) {
                next.email = e.email ?? '';
                next.prefilledEmail = e.email;
            }
            return next;
        }
        case 'numberChanged':
            return {
                name: s.prefilledName !== null && s.name === s.prefilledName ? '' : s.name,
                email: s.prefilledEmail !== null && s.email === s.prefilledEmail ? '' : s.email,
                prefilledName: null,
                prefilledEmail: null,
            };
        case 'typed':
            return e.field === 'name' ? { ...s, name: e.value } : { ...s, email: e.value };
    }
}
export function changedFromPrefill(s) {
    return {
        name: s.name.trim() !== '' && s.name !== (s.prefilledName ?? ''),
        email: s.email.trim() !== '' && s.email !== (s.prefilledEmail ?? ''),
    };
}
//# sourceMappingURL=capture-prefill.js.map